export const TEST_METHOD = 'TEST_METHOD';
export const CHANGE_THEME = 'CHANGE_THEME';
export const SHOW_BUTTONS = 'SHOW_BUTTONS';
export const SHOW_TRANSLATE = 'SHOW_TRANSLATE';
export const USER_INFO = 'USER_INFO';
export const GAME_INFO = 'GAME_INFO';
export const DELETE_GAME_INFO = 'DELETE_GAME_INFO';
export const CHANGE_TEXTBOOK_GROUP = 'CHANGE_TEXTBOOK_GROUP';
